module.exports = __webpack_public_path__ + "img/feima.png";